import {useGenericCtaAction} from '../../../../../../brand/components/GenericCtaAction/use-generic-cta-action'
import type {ResolvedGenericCta} from '../../../../../../brand/lib/types/contentful'

import Styles from './CtaButtons.module.css'

type Props = {
  contentfulContent: ResolvedGenericCta
  location: string
}

export function CtaButtons(props: Props) {
  const {contentfulContent, location} = props

  const {primary, secondary} = contentfulContent
  const primaryAction = useGenericCtaAction(primary, {
    analytics: {tag: 'button', context: 'primary_CTA', location},
    variant: 'primary',
    size: 'medium',
    className: Styles.Button,
  })
  const secondaryAction = useGenericCtaAction(secondary, {
    analytics: {tag: 'button', context: 'secondary_CTA', location},
    size: 'medium',
    className: Styles.Button,
  })

  return (
    <>
      <div className={Styles.CtaButtons}>
        {primaryAction.action}
        {secondaryAction.action}
      </div>

      {primaryAction.feedback}
      {secondaryAction.feedback}
    </>
  )
}
